import script from "./categories-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./categories-bar.vue?vue&type=script&setup=true&lang=js"

import "./categories-bar.vue?vue&type=style&index=0&id=3e4ffc17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e4ffc17"]])

export default __exports__